import Link from 'gatsby-link';
import PropTypes from 'prop-types';
import React from 'react';

const Fleuron = ({ link }) => (
  <p style={{ textAlign: 'center', fontSize: '150%' }}>
    <Link to={link} style={{ textDecoration: 'none' }}>
      ❦
    </Link>
  </p>
);

Fleuron.propTypes = {
  link: PropTypes.string,
};

Fleuron.defaultProps = {
  link: '/',
};

export default Fleuron;



// WEBPACK FOOTER //
// ./src/components/Fleuron.js